var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-card',[_c('v-card-text',[_c('TocList')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }